(function() {
  'use strict';

  angular.module('survey.surveyIntro', [])
    .controller('SurveyIntroCtrl', SurveyIntroCtrl);

  SurveyIntroCtrl.$inject = ['$scope'];

  function SurveyIntroCtrl($scope) {
    $scope.state = {
      numberOfQuestions: 0,
      numberOfCompletedQuestions: 0
    };

    function setup() {
      if (!$scope.currentSlide || $scope.currentSlide.__type !== 'SurveyFirstSlideInfo')
        return;

      var surveyInfo = $scope.quizIdAmountOfQuestions[$scope.currentSlide.surveyId];
      $scope.state.numberOfQuestions = surveyInfo ? surveyInfo.total : 0;
      $scope.state.numberOfCompletedQuestions = surveyInfo ? surveyInfo.completed : 0;
    }

    setup();
  }
})();